import firestore from "../firebase/firestore";

export const addCooperativeFb = (uid, cooperative) => {
  cooperative.updated_at = new Date();
  cooperative.created_at = new Date();
  try {
    if (uid) {
      const ref = firestore.collection("cooperatives");
      return ref.doc(uid).set(cooperative);
    } else {
      const ref = firestore.collection("cooperatives");
      return ref.add(cooperative);
    }
  } catch (err) {
    console.error("Erro ao adicionar a cooperativa", err);
    return null;
  }
};

export const updateCooperativeFb = async (id, cooperative) => {
  const ref = firestore.doc(`cooperatives/${id}`);
  cooperative.updated_at = new Date();
  return await ref
    .update(cooperative)
    .then(() => {
      return ref.get();
    })
    .catch(() => {
      console.error("Erro ao atualizar a cooperativa");
      return null;
    });
};
